<div class="engine-scroll" *ngIf="show" @show (@show.done)="onShowDone($event)">
  <div class="engine-scroll__label">
      Use control + scroll to zoom
  </div>
</div>
